module.exports = __webpack_public_path__ + "static/media/er-logos.fa0466e0.png";